import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FeatureModalModule } from 'src/app/shared/feature-modal/feature-modal.module';
import { FormHelperModule } from 'src/app/shared/form/form-hepler.module';
import { ImageUploadModule } from 'src/app/shared/shared.module';
import { ClockComponent } from './clock/clock.component';
import { PatientInvoicePendingWidgetComponent } from './patient-invoice-pending-widget/patient-invoice-pending-widget.component';
import { RecentPatientWidgetComponent } from './recent-patient-widget/recent-patient-widget.component';
import { TokenWidgetComponent } from './token-widget/token-widget.component';
import { WaitingListComponent } from './waiting-list/waiting-list.component';
import { GetTokenComponent } from './get-token/get-token.component';

@NgModule({
  declarations: [ClockComponent, TokenWidgetComponent, PatientInvoicePendingWidgetComponent, RecentPatientWidgetComponent, WaitingListComponent, GetTokenComponent,],
  imports: [CommonModule, ImageUploadModule, ReactiveFormsModule, FormHelperModule, FeatureModalModule],
  exports: [ClockComponent, TokenWidgetComponent, PatientInvoicePendingWidgetComponent, RecentPatientWidgetComponent, WaitingListComponent, GetTokenComponent]
})
export class WidgetModule { }
